import { render, staticRenderFns } from "./NoteFormNews.vue?vue&type=template&id=5401444e"
import script from "./NoteFormNews.vue?vue&type=script&lang=js"
export * from "./NoteFormNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports